<template>
  <div
    class="SearchableInput"
    :class="{ _isMapCatering: isMapCatering }"
    v-click-outside="clickOutsideHandler"
  >
    <div v-if="isMapCatering" class="search-logo">
      <LogoIcon color="#fff" />
    </div>

    <VInput
      v-model:value="lazyValue"
      placeholder="Поиск"
      @input="onInput"
      @focus="onFocus"
      is-search
      is-clear
    />

    <transition name="popover">
      <div v-if="isOpened" class="suggestions">
        <div
          v-for="(item, index) in results"
          :key="item.id || index"
          class="suggestion"
          @click="onClick(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import VInput from "./VInput";
import debounce from "lodash.debounce";
import LogoIcon from "@/components/icons/LogoIcon.vue";

export default {
  name: "SearchableInput",

  components: {
    LogoIcon,
    VInput,
  },

  props: {
    items: {
      type: Array,
    },
    value: {
      type: String,
    },
    isMapCatering: {
      type: Boolean,
    },
  },

  data() {
    return {
      lazyValue: "",
      isOpened: false,
      selectedItem: null,
      resultsCount: 3,
      results: [],
    };
  },

  watch: {
    lazyValue(newQuestion) {
      if (newQuestion === "") {
        this.$emit("update", this.lazyValue);
        this.$emit("click-update", "");
      }
    },
    value: {
      handler(newValue) {
        this.lazyValue = newValue;
      },
      immediate: true,
    },
  },

  methods: {
    getResults() {
      const search = this.lazyValue?.toLowerCase() ?? "";

      const seen = new Set();

      this.results = this.items
        .filter((e) => {
          const name = e.name?.toLowerCase() ?? "";
          const altName = e.altName?.toLowerCase() ?? "";

          return !search || name.includes(search) || altName.includes(search);
        })
        .filter((e) => {
          const key = (e.name ?? "") + "|" + (e.altName ?? "");
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        })
        .slice(0, this.resultsCount);
    },

    onInput: debounce(async function () {
      this.selectedItem = null;
      this.getResults();
      this.isOpened = !!this.results.length;
    }, 300),

    onFocus() {
      this.onInput();
    },

    clickOutsideHandler() {
      this.isOpened = false;
      if (!this.selectedItem) {
        this.lazyValue = "";
      }
    },

    onClick(item) {
      this.selectedItem = item;
      this.lazyValue = item.name;
      this.$emit("update", item.name);
      this.$emit("click-update", item.name);
      this.isOpened = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.SearchableInput {
  position: relative;

  &._isMapCatering {
    :deep(.v-input) {
      height: 48px;
      background-color: #f6f6f6;
    }

    :deep(.v-input__native) {
      padding-left: 62px;
    }
  }
}

.search-logo {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f18e35;
  width: 48px;
  height: 48px;
  border-radius: 10px;
  z-index: 5;

  svg {
    width: 30px;
    height: 17px;
  }
}

.suggestions {
  position: absolute;
  z-index: 90;
  display: flex;
  align-items: stretch;
  width: 100%;
  max-height: 300px;
  border-radius: 8px;
  margin-top: 8px;
  background-color: white;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);

  &:global(.popover-enter-active),
  &:global(.popover-leave-active) {
    opacity: 1;
    transform: translate3d(0, 0, 0);
    transition: transform 0.3s ease, opacity 0.3s ease;
  }

  &:global(.popover-enter),
  &:global(.popover-leave-to) {
    opacity: 0;
    transform: translate3d(0, 8px, 0);
    transition: transform 0.3s ease, opacity 0.3s ease;
  }
}

.suggestion {
  padding: 9px 12px;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #2a2a30;
  transition: background-color 0.3s ease-in-out;
  cursor: pointer;
  user-select: none;

  &:hover {
    background-color: #ebebeb;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #ebebeb;
  }
}
</style>
